module.exports = __webpack_public_path__ + "img/i_goto.2f9d7e84.png";